import React from 'react'
import Button from '@material-ui/core/Button'
import {useTranslation} from "react-i18next";

const SubscriptionSettingsActions = (props) => {
  const {t} = useTranslation();

  const handleClick = (event) => {
    props.onHandleEditBilling()
  };

  return (
      <Button onClick={handleClick}
              variant="contained"
              color="primary">
        {t('general.edit')}
      </Button>
  )
}

export default SubscriptionSettingsActions
